import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api.js";
import { Card, PageHeader, SeverityBadge, Spinner, Table } from "../components/ui.js";
import { inconsistencyDetail, kindLabel } from "../lib/labels.js";
import { ComoFuncionaInconsistencias } from "../components/ComoFuncionaInconsistencias.js";

export function Inconsistencias() {
  const list = useQuery({ queryKey: ["inconsistencias"], queryFn: async () => (await api.get("/inconsistencias")).data as Record<string, unknown>[] });
  const rows = list.data ?? [];

  // Agrupa por tipo para os cartões de resumo (com rótulo amigável).
  const byKind = rows.reduce<Record<string, number>>((acc, r) => {
    const k = String(r.kind ?? "outros");
    acc[k] = (acc[k] ?? 0) + 1;
    return acc;
  }, {});

  return (
    <div>
      <PageHeader title="Central de inconsistências" subtitle="Qualidade de dados verificada a cada importação da planilha" />
      <ComoFuncionaInconsistencias />
      {list.isLoading ? <Spinner /> : (
        <>
          <div className="mb-6 grid grid-cols-2 gap-4 md:grid-cols-4">
            {Object.entries(byKind).map(([k, n]) => (
              <Card key={k}>
                <div className="text-xs font-semibold uppercase text-slate-500">{kindLabel(k)}</div>
                <div className="mt-1 text-2xl font-bold text-slate-900">{n}</div>
              </Card>
            ))}
          </div>
          <Table
            columns={[
              { key: "kind", label: "Tipo", render: (v) => kindLabel(String(v ?? "")) },
              { key: "severity", label: "Severidade", render: (v) => (v ? <SeverityBadge value={String(v)} /> : "—") },
              { key: "sheet", label: "Aba" },
              { key: "location", label: "Local", render: (v) => (v ? String(v) : "—") },
              { key: "detail", label: "Detalhe", render: (v, row) => (
                <span className="text-xs text-slate-600">{inconsistencyDetail(String(row.kind ?? ""), v)}</span>
              ) },
            ]}
            rows={rows.slice(0, 200)}
          />
        </>
      )}
    </div>
  );
}
